export const CURVA_FORM_ID = "curva-form";

export const TITULO_NOVA = "Nova curva";
export const TITULO_EDICAO = "Editar curva";

export const NOME_LABEL = "Nome da curva";
export const NOME_MAX = 80;
export const NOME_OBRIGATORIO = "Informe o nome da curva.";
export const NOME_MUITO_LONGO = `O nome pode ter até ${NOME_MAX} caracteres.`;

export const CATEGORIA_LABEL = "Categoria";
export const CATEGORIA_PLACEHOLDER = "Selecione";
export const CATEGORIA_OBRIGATORIA = "Selecione a categoria.";

export const FASES_TITULO = "Fases";
export const FASE_ANTES_TITULO = "Antes do início";
export const FASE_ANTES_APOIO =
  "Meses máximos. Se faltar menos tempo para o início da Obra, o % se divide pelos meses que faltam.";
export const FASE_DURANTE_TITULO = "Durante (a partir do início)";
export const FASE_DURANTE_APOIO = "Os meses vêm do prazo da Obra.";
export const FASE_APOS_TITULO = "Após";
export const PERCENTUAL_LABEL = "%";
export const MESES_LABEL = "Meses";

export const PERCENTUAL_INVALIDO = "O percentual deve estar entre 0 e 100.";
export const MESES_INVALIDO = "Os meses devem ser um número inteiro de 0 a 24.";
export const MESES_MAX = 24;
export const MESES_OBRIGATORIO_ANTES = "Informe pelo menos 1 mês para a fase Antes.";
export const MESES_OBRIGATORIO_APOS = "Informe pelo menos 1 mês para a fase Após.";

export const SOMA_ALVO = 100;
export const SOMA_TOLERANCIA = 0.01;
export const SOMA_INVALIDA = "A soma dos percentuais deve ser 100%. Ajuste as fases para salvar.";

export const totalMesesTexto = (meses: number) =>
  meses === 0
    ? "Total: prazo da Obra."
    : `Total: prazo da Obra + ${meses} ${meses === 1 ? "mês" : "meses"} (Antes e Após).`;

export const usoTexto = (escopos: number, obras: number) =>
  `Esta curva é usada em ${escopos} ${escopos === 1 ? "escopo macro" : "escopos macro"} de ${obras} ${obras === 1 ? "Obra" : "Obras"}. A alteração vale só para as novas seleções; esses escopos mantêm a mensalização atual.`;
